import React from 'react';
import FormSteps from '../FormSteps';
import FormField from '../../../../FormField';

/**
 * @param {Object} formik
 * @param {Function} goToNextStep
 * @param {Function} skipStep
 */
const BrandNameInputStep = ({ formik, goToNextStep, skipStep }) => {
    const handleNext = () => {
        goToNextStep('brandName');
    };

    const handleSkip = () => {
        formik.setFieldValue('brandName', '');
        skipStep();
    };

    return (
        <FormSteps
            header="What is your brand name?"
            description="Enter the official name of your brand or company."
            nextButton={handleNext}
            skipButton={handleSkip}
        >
            <div className="field mb-6">
                <div className="field-body">
                    <FormField
                        additionalInputClasses="has-background-white"
                        name="brandName"
                        placeholder="Enter name"
                        onChange={formik.handleChange}
                        value={formik.values.brandName}
                        onBlur={formik.handleBlur}
                    />
                </div>
                {formik.touched.brandName && formik.errors.brandName && (
                    <p className="help is-danger">{formik.errors.brandName}</p>
                )}
            </div>
        </FormSteps>
    );
};

export default BrandNameInputStep;